// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"915a4bda","93":"4ed7212b","107":"4a4c10eb","223":"4080487c","260":"3c4062dc","488":"9193d111","609":"d6a276e5","803":"5404a40b","859":"c008a2c4","983":"7660141a"}[chunkId] + ".chunk.js";
};